import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { Container } from "react-bootstrap";
import styles from "./LoginLayout.module.scss";
import LoginFooter from "../LoginFooter";
import LoginLogo from "../LoginLogo";

const LoginLayout = ({
  children
}) => {
  return /*#__PURE__*/React.createElement("div", {
    className: styles.wrapper
  }, /*#__PURE__*/React.createElement(LoginLogo, null), /*#__PURE__*/React.createElement(Container, {
    className: classNames(styles.container, "py-5")
  }, children), /*#__PURE__*/React.createElement(LoginFooter, {
    className: styles.footer
  }));
};

LoginLayout.propTypes = {
  children: PropTypes.node
};
export default LoginLayout;